import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class MddValidators {
    static DATE_REGEX =
        /(\d{4}[/-](0?[1-9]|1[012])[/-]([12][0-9]|0?[1-9]|3[01]))|((0?[1-9]|1[012])[/-](0?[1-9]|[12][0-9]|3[01])[/-]\d{4})/;
    static EMAIL_REGEX =
        /[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-z0-9](?:[A-z0-9-]*[A-z0-9])?\.)+[A-z0-9](?:[A-z0-9-]*[A-z0-9])?/;

    static email(control: AbstractControl): ValidationErrors | null {
        return MddValidators.EMAIL_REGEX.test(control.value)
            ? null
            : {
                  invalidEmail: true
              };
    }

    static date(control: AbstractControl): ValidationErrors | null {
        const test = MddValidators.DATE_REGEX.test(control.value);
        return test
            ? null
            : {
                  invalidDate: true
              };
    }

    static minDate<T>(obj: T, minDateKey: keyof T): ValidatorFn {
        return (control: AbstractControl) => {
            if (control.value && control.value < obj[minDateKey]) {
                return { minDate: obj[minDateKey] };
            } else {
                return null;
            }
        };
    }

    static maxDate<T>(obj: T, maxDateKey: keyof T): ValidatorFn {
        return (control: AbstractControl) => {
            if (control.value && control.value > obj[maxDateKey]) {
                return { maxDate: obj[maxDateKey] };
            } else {
                return null;
            }
        };
    }
}
